
import imagesLoaded from "imagesloaded";

/**
 * Will preload images
 * @return {Promise<void>}
 * @private
 */
const _preloadImages = () => {
    return new Promise((resolve, reject) => {
        const imgLoad = imagesLoaded(
            document.querySelectorAll("img"),
            {
                background: true,
            },
            resolve
        );
    });
};

export default function preloadImages(){
    _preloadImages().then(() => {
        const bodyEl = document.querySelector("body");
        const event = new CustomEvent("pageloaded");
        bodyEl.classList.remove("loading");
        document.dispatchEvent(event);
    });
}